/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Collectibles } from './Collectibles';
import {
    CollectiblesFromJSON,
    CollectiblesFromJSONTyped,
    CollectiblesToJSON,
} from './Collectibles';

/**
 * 
 * @export
 * @interface CollectiblesResponse
 */
export interface CollectiblesResponse {
    /**
     * 
     * @type {Collectibles}
     * @memberof CollectiblesResponse
     */
    data?: Collectibles;
}

/**
 * Check if a given object implements the CollectiblesResponse interface.
 */
export function instanceOfCollectiblesResponse(value: object): value is CollectiblesResponse {
    let isInstance = true;

    return isInstance;
}

export function CollectiblesResponseFromJSON(json: any): CollectiblesResponse {
    return CollectiblesResponseFromJSONTyped(json, false);
}

export function CollectiblesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectiblesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CollectiblesFromJSON(json['data']),
    };
}

export function CollectiblesResponseToJSON(value?: CollectiblesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CollectiblesToJSON(value.data),
    };
}

